<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Listado de Lineas Credito</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <NuevaLineaCreditoModalComponent />
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
                >Refrescar</a
              >
            </div>
            <div class="col-sm-6">
              <div class="form-inline justify-content-sm-end">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="filterData()"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData()"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_estado"
                  @change="filterData()"
                >
                  <option value>Todos</option>
                  <option :value="true">Activo</option>
                  <option :value="false">Inactivo</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <LineaCreditoTableComponent :dataTabla="dataTabla" />
        <PaginationComponent
          :currentPage="currentPage"
          :data="dataTabla"
          @pagechanged="filterData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import LineaCreditoTableComponent from "@/components/cxc/linea_credito/LineaCreditoTableComponent";
import NuevaLineaCreditoModalComponent from "@/components/cxc/linea_credito/NuevaLineaCreditoModalComponent";
import DynamicService from "@/services/commons/DynamicService";
export default {
  components: {
    UsuarioEnTablaComponent,
    LineaCreditoTableComponent,
    NuevaLineaCreditoModalComponent,
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      dataTabla: [],
      params: "",
    };
  },
  mounted() {
    let self = this;
    self.refresh();
  },
  methods: {
    refresh(params) {
      let self = this;
      DynamicService.fetch("cxc", "linea-credito", params).then((response) => {
        self.dataTabla = response.data;
      });
    },
    filterData(page) {
      let self = this;
      if (page) {
        this.currentPage = page;
      }
      self.params = {
        page: this.currentPage,
        "filter[search]": this.$data.searchtext,
        estatus: this.filtro_estado,
      };
      self.refresh(self.params);
    },
    clearFilterData() {
      let self = this;
      this.$data.searchtext = "";
      this.$data.currentPage = 1;
      self.params = {
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
      };
      self.refresh(self.params);
    },
  },
};
</script>
